module.exports = __webpack_public_path__ + "static/media/down.4137435b.svg";